/**
 * NonProdPeopleApiWarning — a warning Alert shown only in non-production
 * environments, where People APIs (PAPI) data is not up to date. The sections
 * that resolve ownership via PAPI render this directly above themselves so the
 * caveat stays adjacent to the potentially-inaccurate data instead of scrolling
 * out of view at the top of the page.
 *
 * The message is section-specific (passed in via `children`) since each section
 * is affected differently; only the non-prod gating and Alert styling are
 * shared here. Renders nothing in prod (or when the stage is unknown).
 */

import React from "react";
import { useSelector } from "react-redux";
import { Alert } from "@amzn/awsui-components-react";

function NonProdPeopleApiWarning({ children }) {
  const currentStage = useSelector((globalState) => globalState.auth.currentStage);

  if (!currentStage || currentStage === "prod") return null;

  return (
    <Alert type="warning" header="Non-production environment">
      {children}
    </Alert>
  );
}

export default NonProdPeopleApiWarning;
